/* eslint-disable react/button-has-type -- idiotic */
import { cn } from "cy-fe/src/utils/cn";
import { LucideProps } from "lucide-react";
import { NextLink } from "cy-fe";
import {
  ComponentType,
  forwardRef,
  type ButtonHTMLAttributes,
  type HTMLAttributes,
} from "react";

export type Sizes = "md";
const iconProps = {
  md: { size: "1.5rem", strokeWidth: 1 },
};

const circleClasses = {
  md: "flex items-center justify-center rounded-full h-min bg-icon_button-color p-3 w-min ",
};
const linkOutlineClasses =
  "ring-0 outline-none border-0 ring-link-ring-focus hover:ring-[length:var(--link-ring-width-focus)] ";
const buttonOutlineClasses =
  "ring-0 outline-none border-0 ring-button-ring-focus hover:ring-[length:var(--button-ring-width-focus)] focus-visible:ring-[length:var(--button-ring-width-focus)] ";

interface CommonProps {
  icon: ComponentType<LucideProps>;
  className?: string;
  vSize?: Sizes;
}
type RoundButtonProps = CommonProps & ButtonHTMLAttributes<HTMLButtonElement>;

type RoundIconProps = CommonProps & HTMLAttributes<HTMLDivElement>;

type RoundButtonLinkProps = CommonProps & {
  href: string;
};
export function RoundButtonLink(props: RoundButtonLinkProps) {
  const { vSize = "md", href, icon: Icon, className } = props;
  return (
    <NextLink
      href={href}
      className={cn(circleClasses[vSize], linkOutlineClasses, className)}
    >
      <div>
        <Icon {...iconProps[vSize]} />
      </div>
    </NextLink>
  );
}

export const RoundButton = forwardRef<HTMLButtonElement, RoundButtonProps>(
  function RoundButton(props: RoundButtonProps, ref) {
    const { type, icon: Icon, vSize = "md", className, ...rest } = props;
    return (
      <button
        type={type || "button"}
        ref={ref}
        className={cn(circleClasses[vSize], buttonOutlineClasses, className)}
        {...rest}
      >
        <Icon {...iconProps[vSize]} />
      </button>
    );
  },
);

export function RoundIcon(props: RoundIconProps) {
  const { icon: Icon, vSize = "md", ...rest } = props;
  return (
    <RoundIconContainer {...rest}>
      <Icon {...iconProps[vSize]} />
    </RoundIconContainer>
  );
}

export type RoundIconContainerProps = HTMLAttributes<HTMLDivElement> & {
  vSize?: Sizes;
};

export function RoundIconContainer(props: RoundIconContainerProps) {
  const { className, vSize = "md", ...rest } = props;
  return <div className={cn(circleClasses[vSize], className)} {...rest} />;
}
